"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSuspenseImageUtilityClass = getSuspenseImageUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getSuspenseImageUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriSuspenseImage', slot);
}
const suspenseImageClasses = (0, _base.generateUtilityClasses)('MuiOriSuspenseImage', ['root']);
var _default = exports.default = suspenseImageClasses;
